import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import AppHeader from './components/Header';
import AppFooter from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Support from './pages/Support';
import TestRedux from './pages/TestRedux';
import Login from './pages/Login';

const { Content } = Layout;

const App = () => {
    return (
        <Router>
            <Layout style={{ minHeight: '100vh' }}>
                <AppHeader />
                <Content style={{ padding: '50px' }}>
                    <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
                        <Routes>
                            <Route path="/" element={<Home myObject={{'name':'mzh'}} />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/support" element={<Support />} />
                            <Route path="/TestRedux" element={<TestRedux />} />
                            <Route path="/Login" element={<Login />} />
                        </Routes>
                    </div>
                </Content>
                <AppFooter />
            </Layout>
        </Router>
    );
};

export default App;
